/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import Video, { type VideoProps } from 'components/Video/Video';
import Text from '../Text/Text';
import './VideoText.scss';

const DEFAULT_VIDEO: VideoProps = {};

interface VideoTextProps {
  layout?: 'left' | 'right';
  dropcap?: boolean;
  text?: string;
  video?: VideoProps;
}

/**
 * This is the VideoText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function VideoText({
  layout = 'left',
  dropcap = false,
  text = '',
  video = DEFAULT_VIDEO,
}: VideoTextProps) {
  return (
    <div className={`block video-text layout-${layout}`}>
      <div className="video-container" appear="true">
        <Video {...video} />
      </div>
      <Text dropcap={dropcap}>{text}</Text>
    </div>
  );
}

export default VideoText;
